/** Errors raised at the lib-jitsi-meet boundary. */

export class JitsiTrackCreationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'JitsiTrackCreationError';
  }
}

export class JitsiConnectionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'JitsiConnectionError';
  }
}
